import { render, staticRenderFns } from "./WhsE.vue?vue&type=template&id=c779e73c"
import script from "./WhsE.vue?vue&type=script&lang=js"
export * from "./WhsE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports